import { a34, a217, a177 } from "./RootApiPath";

class PayLoadService {


  async sendPayloadupdate(items) {

    console.error('checking items ', items);
    const payload = this.constructPayload1(items);

    console.error('checking payload ', payload);

    try {
      const response = await fetch("https://soni.loyalstring.co.in/api/ProductMaster/UpdateLabeledStock", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorDetails = await response.json(); // Parse error details
        throw new Error(
          JSON.stringify({
            status: response.status,
            message: errorDetails.Title || 'API call failed',
            errors: errorDetails.Errors || {},
            traceId: errorDetails.traceId || null,
          })
        );
      }

      return await response.json(); // Returns the API response
    } catch (error) {
      console.error('Error in API call:', error);
      throw error; // Propagate error back to the caller
    }
  }

  async sendPayload(items) {

    console.error('checking items ', items);
    const payload = this.constructPayload(items);

    console.error('checking payload ', payload);

    try {
      const response = await fetch(a217, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorDetails = await response.json(); // Parse error details
        throw new Error(
          JSON.stringify({
            status: response.status,
            message: errorDetails.Title || 'API call failed',
            errors: errorDetails.Errors || {},
            traceId: errorDetails.traceId || null,
          })
        );
      }

      return await response.json(); // Returns the API response
    } catch (error) {
      console.error('Error in API call:', error);
      throw error; // Propagate error back to the caller
    }
  }

  constructPayload1(items) {
    return items.map((item) => {


      // Check the product type (Loose Diamond, Loose Stone, or Others)
      if (item.CategoryName === "LOOSE DIAMOND") {
        return {
          ...item,
          ProductId:'0',
          DesignId:'0',
          PurityId:'0',
          CollectionId:'0',
          PacketId:'0',
          WeightCategory:'0',
          TotalWeight:'0',
          PackingWeight:'0',
          Stones:[],
          SKUId:'0',
          LotNumber:'0',
          DiamondAmount: String(item.DiamondAmount || "0"),
          DiamondWeight: String(item.DiamondWeight || "0"),
          DiamondRate: String(item.DiamondRate || '0'),
          DiamondPieces: String(item.DiamondPieces || '0'),
          DiamondSize: String(item.DiamondSize || ''),
          BoxId: parseInt(item.BoxId, 10) || 0,

        };
      }

      if (item.ProductType === 'LooseStone') {
        return {
          ...item,
          StoneAmount: String(item.StoneAmount || "0"),
          StoneWeight: String(item.StoneWeight || "0"),
          StonePieces: String(item.StonePieces || "0"),
          StoneRate: String(item.StoneRate || '0')

        };
      }

      // For others (regular products)
      return {
        ...item,
        grosswt: String(item.GrossWt), // Ensure property names are correct
        GrossWt: String(item.GrossWt),
        CollectionId: item.CollectionId || 0,
        PacketId: item.PacketId || 0,
        BoxId: parseInt(item.BoxId || 0),
        WeightCategory: item.WeightCategory || 0,
        PackingWeight: item.PackingWeight || 0,
        LotNumber: item.LotNumber || '0',
        SKUId: parseInt(item.SKUId || 0),
        TotalStoneWeight: String(item.TotalStoneWeight || "0"),
        TotalStoneAmount: String(item.TotalStoneAmount || "0"),
        TotalStonePieces: String(item.TotalStonePieces || "0"),
        TotalDiamondWeight: String(item.TotalDiamondWeight || "0"),
        TotalDiamondAmount: String(item.TotalDiamondAmount || "0"),
        NetWt: String(item.NetWt || '0'),
        Status: 'Active',
        Stones: item.Stones.map(stone => ({
          ...stone,
          StoneName:stone.StoneName || '0',          
          StoneWeight:String(stone.StoneWeight || "0"),
          StonePieces:String(stone.StonePieces || "0"),
          StoneRate: stone.StoneRateKarate !== undefined ? String(stone.StoneRateKarate) : "0",
          StoneAmount:String(stone.StoneAmount || "0"),
          Description:stone.Description || '0',
          ClientCode:item.ClientCode || '0',
          CompanyId:item.CompanyId || '0',
          CounterId:item.CounterId || '0',
          BranchId:item.BranchId || '0',
          EmployeeId:item.EmployeeId || '0',
          StoneLessPercent:stone.StoneLessPercent || '0',
          StoneCertificate:stone.StoneCertificate || '0',
          StoneColour:stone.StoneColour || '0',
          StoneSettingType:stone.StoneSettingType || '0',
          StoneShape:stone.StoneShape || '0',
          StoneSize:stone.StoneSize || '0',
          StoneRatePerPiece:stone.StoneRatePiece || '0',
          StoneWeightType:stone.StoneWeightType || '0',
          StoneCategory:stone.StoneCategory || '0',
          StoneRateKarate: stone.StoneRateKarate !== undefined ? String(stone.StoneRateKarate) : '0'

          // StoneAmount: String(stone.StoneAmount || "0"), // Convert to string
          // StoneWeight: String(stone.StoneWeight || "0"), // Convert to string
          // StonePieces: String(stone.StonePieces || "0"),
          // StoneRate: String(stone.StoneRate || '0'),
          // StoneColour: stone.StoneColor || '0',

        })),
        // Diamonds: item.Diamonds?.map(stone => ({
        //   ...stone,
        //   DiamondAmount: String(stone.DiamondAmount || "0"), // Convert to string
        //   DiamondWeight: String(stone.DiamondWeight || "0"), // Convert to string

        //   DiamondRate: String(stone.DiamondRate || '0'),
        //   DiamondPieces: String(stone.DiamondPieces || '0'),
        //   DiamondSize: String(stone.DiamondSize || '')
        // })),
      }
    })




  }


  constructPayload(items) {
    return items.map((item) => {


      // Check the product type (Loose Diamond, Loose Stone, or Others)
      if (item.CategoryName === "LOOSE DIAMOND") {
        return {
          ...item,
          ProductId:'0',
          DesignId:'0',
          PurityId:'0',
          CollectionId:'0',
          PacketId:'0',
          WeightCategory:'0',
          TotalWeight:'0',
          PackingWeight:'0',
          Stones:[],
          SKUId:'0',
          LotNumber:'0',
          DiamondAmount: String(item.DiamondAmount || "0"),
          DiamondWeight: String(item.DiamondWeight || "0"),
          DiamondRate: String(item.DiamondRate || '0'),
          DiamondPieces: String(item.DiamondPieces || '0'),
          DiamondSize: String(item.DiamondSize || ''),
          BoxId: parseInt(item.BoxId, 10) || 0,

        };
      }

      if (item.ProductType === 'LooseStone') {
        return {
          ...item,
          StoneAmount: String(item.StoneAmount || "0"),
          StoneWeight: String(item.StoneWeight || "0"),
          StonePieces: String(item.StonePieces || "0"),
          StoneRate: String(item.StoneRate || '0')

        };
      }

      // For others (regular products)
      return {
        ...item,
        grosswt: String(item.GrossWt), // Ensure property names are correct
        GrossWt: String(item.GrossWt),
        CollectionId: item.CollectionId || 0,
        PacketId: item.PacketId || 0,
        BoxId: parseInt(item.BoxId || 0),
        WeightCategory: item.WeightCategory || 0,
        PackingWeight: item.PackingWeight || 0,
        LotNumber: item.LotNumber || '0',
        SKUId: parseInt(item.SKUId || 0),
        TotalStoneWeight: String(item.TotalStoneWeight || "0"),
        TotalStoneAmount: String(item.TotalStoneAmount || "0"),
        TotalStonePieces: String(item.TotalStonePieces || "0"),
        TotalDiamondWeight: String(item.TotalDiamondWeight || "0"),
        TotalDiamondAmount: String(item.TotalDiamondAmount || "0"),
        NetWt: String(item.NetWt || '0'),
        Status: 'Active',
        Stones: item.Stones.map(stone => ({
          ...stone,
          StoneName:stone.StoneName || '0',          
          StoneWeight:String(stone.StoneWeight || "0"),
          StonePieces:String(stone.StonePieces || "0"),
          StoneRate: stone.StoneRateKarate !== undefined ? String(stone.StoneRateKarate) : "0",
          StoneAmount:String(stone.StoneAmount || "0"),
          Description:stone.Description || '0',
          ClientCode:item.ClientCode || '0',
          CompanyId:item.CompanyId || '0',
          CounterId:item.CounterId || '0',
          BranchId:item.BranchId || '0',
          EmployeeId:item.EmployeeId || '0',
          StoneLessPercent:stone.StoneLessPercent || '0',
          StoneCertificate:stone.StoneCertificate || '0',
          StoneColour:stone.StoneColour || '0',
          StoneSettingType:stone.StoneSettingType || '0',
          StoneShape:stone.StoneShape || '0',
          StoneSize:stone.StoneSize || '0',
          StoneRatePerPiece:stone.StoneRatePiece || '0',
          StoneWeightType:stone.StoneWeightType || '0',
          StoneCategory:stone.StoneCategory || '0',
          // StoneAmount: String(stone.StoneAmount || "0"), // Convert to string
          // StoneWeight: String(stone.StoneWeight || "0"), // Convert to string
          // StonePieces: String(stone.StonePieces || "0"),
          // StoneRate: String(stone.StoneRate || '0'),
          // StoneColour: stone.StoneColor || '0',

        })),
        // Diamonds: item.Diamonds?.map(stone => ({
        //   ...stone,
        //   DiamondAmount: String(stone.DiamondAmount || "0"), // Convert to string
        //   DiamondWeight: String(stone.DiamondWeight || "0"), // Convert to string

        //   DiamondRate: String(stone.DiamondRate || '0'),
        //   DiamondPieces: String(stone.DiamondPieces || '0'),
        //   DiamondSize: String(stone.DiamondSize || '')
        // })),
      }
    })




  }
}

export default PayLoadService;
